
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/estate-agents/featured-listing",
      function () {
        return require("private-next-pages/products/estate-agents/featured-listing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/estate-agents/featured-listing"])
      });
    }
  